import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Text = makeShortcode("Text");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Text sx={{
      fontSize: [3, 4, 5],
      fontWeight: `bold`,
      color: `heading`
    }} mdxType="Text">
  Salut
    </Text>
    <p>{`I am Dragoș (Dragosh), a Frontend Software Engineer,
Hackathoner, OSS enthusiast.`}<br />{`
Follow me on twitter `}<a parentName="p" {...{
        "href": "https://twitter.com/strdr4605"
      }}>{`@strdr4605`}</a>{` to get updates about latest posts.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      